const pickString = value => {
  if (typeof value === 'string' && value.trim()) {
    return value
  }
  if (Array.isArray(value)) {
    const first = value.find(item => typeof item === 'string' && item.trim())
    return first || undefined
  }
  return undefined
}

export const getApiErrorMessage = err => {
  const data = err && err.response && err.response.data
  if (!data) {
    return undefined
  }

  const asString = pickString(data)
  if (asString) {
    return asString
  }

  const candidates = [
    data.error && data.error.message,
    data.exception && data.exception.response && data.exception.response.message,
    data.nestjsError && data.nestjsError.response && data.nestjsError.response.message,
    data.message,
    data.exception && data.exception.message,
    data.nestjsError && data.nestjsError.message,
    data.error,
  ]

  for (const candidate of candidates) {
    const message = pickString(candidate)
    if (message) {
      return message
    }
  }

  return undefined
}

// The API's own message is what tells the user why a call failed, so it is what gets shown.
// The one thing it cannot carry is a raw i18n key: api-next fills the `{{field}}` slot of a 422
// with `system.field.<name>` and does not translate those keys yet, so the key arrives verbatim
// inside an otherwise translated sentence ("system.field.unverified_phone has to be less than 16
// characters"). Drop the key and keep the sentence -- the reason is the useful part. Once
// api-next translates those keys nothing is stripped and the full sentence is shown. Returns
// undefined when nothing usable is left, so the caller can fall back to its own generic message.
export const cleanApiErrorMessage = message => {
  if (typeof message !== 'string') {
    return undefined
  }

  const cleaned = message
    .replace(/system(\.[a-z0-9_]+)+/gi, '')
    .replace(/\s+/g, ' ')
    .trim()

  return cleaned ? cleaned.charAt(0).toUpperCase() + cleaned.slice(1) : undefined
}



// WEBPACK FOOTER //
// ./src/utils/apiError.js